import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { IEmployee } from '@entities/employee/model/types';

export const useAddEmployeeFromCompanyPage = () => {
    const [isShow, setIsShow] = useState(false);

    const { t } = useTranslation();

    const onShowModal = () => setIsShow(true);

    const onHideModal = () => {
        setIsShow(false);
    };

    const onSuccessCb = () => {
        // const prototype = `<tr class="employee-position">
        //                 <td class="py-1 employee-avatar"></td>
        //                 <td class="employee-full-name"></td>
        //                 <td class="employee-position"><i></i></td>
        //                 <td class="employee-email"></td>
        //                 <td>
        //                 <i class="la la-cog fs-21 show-details-button cursor-pointer hover-opacity modalable" data-modalable-close="false"></i>
        //                 <i class="la la-trash-o cursor-pointer hover-opacity fs-21 ml-3" data-employee-action="remove"></i>
        //                 </td>
        //                 </tr>`;
        //
        // const $row = $(prototype);
        //
        // if (data.avatar) {
        //     $row.find('.employee-avatar').html(
        //         // @ts-ignore
        //         `<img class="modalable cursor-pointer" data-modalable-close="false" data-modalable-url="${helpable.replaceUrlParameters(
        //             // @ts-ignore
        //             routable.getRoute('detailsEmployee'),
        //             { _email_: data.email }
        //         )}" src="${data.avatar}" alt="">`
        //     );
        // } else {
        //     $row.find('.employee-avatar').html(
        //         // @ts-ignore
        //         `<div class="employee no-photo modalable cursor-pointer" data-modalable-close="false" data-modalable-url="${helpable.replaceUrlParameters(
        //             // @ts-ignore
        //             routable.getRoute('detailsEmployee'),
        //             { _email_: data.email }
        //         )}"></div>`
        //     );
        // }
        // if (data.name) {
        //     $row.find('.employee-full-name').html(
        //         // @ts-ignore
        //         `<span class="modalable cursor-pointer" data-modalable-close="false" data-modalable-url="${helpable.replaceUrlParameters(
        //             // @ts-ignore
        //             routable.getRoute('detailsEmployee'),
        //             { _email_: data.email }
        //         )}">${data.name}<span>`
        //     );
        // } else {
        //     $row.find('.employee-full-name').text(data.email);
        // }
        //
        // $row.find('.employee-email').text(data.email);
        // $row.find('.employee-position > i').text(data.position);
        // $row.find('[data-employee-action=remove]').attr('data-employee-id', data.id);
        //
        // $row.find('.show-details-button').attr(
        //     'data-modalable-url',
        //     // @ts-ignore
        //     helpable.replaceUrlParameters(routable.getRoute('detailsEmployee'), {
        //         _email_: data.email,
        //     })
        // );
        // $('.employee-list').append($row);
        // $('#added-user-count').text(parseInt($('#added-user-count').text()) + 1);
        window.location.reload();
    };
    return { onSuccessCb, isShow, onShowModal, onHideModal, t };
};
